const initOfferTab = () => {
  const buttonContainer = document.querySelector(
    ".offer-container .offer-header .button-container",
  );
  if (!buttonContainer) return;

  const handleTabToggle = () => {
    const tabContent = document.querySelector(".offer-container");
    const arrow = document.querySelector(
      ".offer-container .offer-header .button-arrow",
    );
    const overlay = document.querySelector(".offer-tabs-overlay");

    tabContent.classList.toggle("show");
    overlay.classList.toggle("show");
    arrow.classList.toggle("up");
  };

  buttonContainer.addEventListener("click", handleTabToggle);

  document.querySelectorAll(".offer-discount-code").forEach((el) => {
    el.addEventListener("click", () => {
      navigator.clipboard.writeText(el.dataset.offercode);
      el.classList.add("show-tooltip");
      setTimeout(() => el.classList.remove("show-tooltip"), 1000);
    });
  });

  document.addEventListener("click", (event) => {
    const container = document.querySelector(".offer-container");
    if (container && !container.contains(event.target)) {
      container.classList.remove("show");
      const overlay = document.querySelector(".offer-tabs-overlay");
      if (overlay) overlay.classList.remove("show");
    }
  });
};

const placeholder = document.getElementById("today-offer-placeholder");

if (placeholder) {
  fetch(`${window.location.pathname}?sections=today-offer`)
    .then((res) => res.json())
    .then((data) => {
      const html = data["today-offer"];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      if (!doc.querySelector(".offer-container")) return;

      placeholder.outerHTML = html;
      initOfferTab();
    })
    .catch((error) => {
      console.warn("[offer-tab] Failed to load today-offer section", error);
    });
} else if (document.querySelector(".offer-container")) {
  initOfferTab();
}
